import { RouteType } from "../types/route.type";
import LoginPage from "../pages/login/LoginPage";
import NotFoundPage from "../pages/notfound/NotFoundPage";
import TestPage from "../pages/test/TestPage";
import AppPage from "../pages/app/AppPage";
import DashboardPage from "../pages/dashboard/DashboardPage";
import TablePage from "../pages/table/TablePage";
import KitchenPage from "../pages/kitchen/KitchenPage";
import PosPage from "../pages/pos/PosPage";
import OrderPage from "../pages/order/OrderPage";
import BookingPage from "../pages/booking/BookingPage";
import ReportPage from "../pages/report/ReportPage";
import PrintVexePage from "../pages/print/vexe/PrintVexePage";
import CategoryPage from "../pages/category/CategoryPage";
import RestaurantPage from "../pages/restaurant/RestaurantPage";
import PrintPBLNHPage from "../pages/print/pbl_nh";

const publicRoutes: RouteType[] = [
  {
    id: "notfound",
    path: "*",
    component: NotFoundPage,
  },
  {
    id: "test",
    path: "/test",
    component: TestPage,
  },
  {
    id: "print_pblnh",
    path: "/print/pbl_nh",
    component: PrintPBLNHPage,
  },
];

const restrictedRoutes: RouteType[] = [
  {
    id: "login",
    path: "/login",
    component: LoginPage,
  },
];
const privateRoutes: RouteType[] = [
  {
    id: "dashboard",
    path: "/",
    component: DashboardPage,
  },
  {
    id: "app",
    path: "/app",
    component: AppPage,
  },
  {
    id: "pos",
    path: "/pos",
    component: PosPage,
  },
  {
    id: "restaurant",
    path: "/restaurant",
    component: RestaurantPage,
  },
  {
    id: "booking",
    path: "/booking",
    component: BookingPage,
  },
  {
    id: "tables",
    path: "/fnb/tables",
    component: TablePage,
  },
  {
    id: "fnb",
    path: "/fnb/:ma_kho/:ma_ban",
    component: OrderPage,
  },
  {
    id: "kitchen",
    path: "/fnb/kitchen",
    component: KitchenPage,
  },
  {
    id: "list",
    path: "/list/:code",
    component: CategoryPage,
  },
  {
    id: "report",
    path: "/report/:code",
    component: ReportPage,
  },
  {
    id: "printvexe",
    path: "/print/vexe/:id",
    component: PrintVexePage,
  },
];

export { publicRoutes, restrictedRoutes, privateRoutes };
